var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientSelectIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "21px",
    viewBox: "0 0 16 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "973E5799-2ED8-4811-B3DF-12F25803109B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stylesheet",
    transform: "translate(-298.000000, -465.000000)",
    fill: "#000000",
    fillRule: "nonzero",
    stroke: "#000000",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape-2",
    transform: "translate(299.000000, 466.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00003849,0 C4.73082191,0 2.88241204,1.9384281 2.88241204,4.31815635 C2.88241204,6.69788461 4.73082191,8.63631271 7.00003849,8.63631271 C9.26925508,8.63631271 11.1176649,6.69788461 11.1176649,4.31815635 C11.1176649,1.9384281 9.26925508,0 7.00003849,0 Z M7.00003849,0.863554161 C8.82418377,0.863554161 10.2942132,2.40513598 10.2942132,4.31815635 C10.2942132,6.23113817 8.8243676,7.77275855 7.00003849,7.77275855 C5.17589321,7.77275855 3.7058638,6.23117673 3.7058638,4.31815635 C3.7058638,2.40517453 5.17570939,0.863554161 7.00003849,0.863554161 Z M3.29417469,10.3634981 C1.4763529,10.3634981 0,11.9117114 0,13.8181003 L0,18.5680723 L0.000143602222,18.5682229 C0.000143602222,18.8066314 0.184396356,19 0.411869483,19 L13.5882741,19 C13.8157546,19 14,18.8066237 14,18.5682229 L14,13.8182509 C14,11.9119006 12.5236839,10.3636487 10.7058253,10.3636487 L3.2940977,10.3636487 L3.29417469,10.3634981 Z M3.29417469,11.2270523 L10.7059023,11.2270523 C12.0817042,11.2270523 13.1764414,12.3751036 13.1764414,13.8179076 L13.1764414,18.1360639 L0.823562054,18.1360639 L0.823562054,13.8179076 C0.823562054,12.3751036 1.91829922,11.2270523 3.29410116,11.2270523 L3.29417469,11.2270523 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientSelectIcon);
export default __webpack_public_path__ + "static/media/client-select-icon.de5e5c3ec263571341e37365368cab56.svg";
export { ForwardRef as ReactComponent };